import React, { useState } from 'react';
import OtpForm from './OtpForm';
import PasswordForm from './PasswordForm';
import Button from '@src/components/ui2/Button';
import { Divider, Title } from './style';
import useTranslate from '@src/i18n/useTranslate';
import { setErrors } from '@src/features/auth';
import { dispatch } from '@src/mocks/constants';

type LoginFormProps = {
  email?: string;
  onSuccess?: () => void;
};

const LoginForm = (props: LoginFormProps) => {
  const { email, onSuccess = () => {} } = props;

  const { i18n } = useTranslate();
  const [loginType, setLoginType] = useState<'password' | 'otp'>('otp');

  const isPasswordLogin = loginType === 'password';
  const isOtpLogin = loginType === 'otp';

  return (
    <>
      <Title>{i18n('direct_link_auth_login_title')}</Title>

      {isPasswordLogin ? (
        <>
          <PasswordForm email={email!} />

          <Divider>-{i18n('direct_link_auth_login_or')}-</Divider>

          <Button
            fullWidth
            outlined
            onClick={() => {
              dispatch(setErrors('login', {}));
              setLoginType('otp');
            }}
          >
            {i18n('direct_link_auth_login_with_otp')}
          </Button>
        </>
      ) : null}

      {isOtpLogin && email ? (
        <>
          <OtpForm email={email} onSuccess={onSuccess} />

          <Divider>-{i18n('direct_link_auth_login_or')}-</Divider>

          <Button
            fullWidth
            outlined
            onClick={() => {
              dispatch(setErrors('login', {}));
              setLoginType('password');
            }}
          >
            {i18n('direct_link_auth_login_with_password')}
          </Button>
        </>
      ) : null}
    </>
  );
};

export default LoginForm;
